export const employmentTypeTranslations: Record<string, string> = {
  permanent: 'Vollzeit',
  parttime: 'Teilzeit',
  partTime: 'Teilzeit',
  freelance: 'Freelance',
  internship: 'Praktikum',
  trainee: 'Trainee Stelle',
  temporary: 'Temporär',
};

export function normalizeEmploymentTypeKey(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[-_]+/g, '');
}

export function formatEmploymentTypeOption(value: string): string {
  const normalized = value.trim().toLowerCase();
  return (
    employmentTypeTranslations[normalized] ??
    employmentTypeTranslations[
      normalized.replace(/-([a-z])/g, (_, letter: string) => letter.toUpperCase())
    ] ??
    value
  );
}

export function parsePreselectedEmploymentTypeOptions(
  value: unknown,
): string[] {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value.filter((entry): entry is string => typeof entry === 'string');
  }

  if (typeof value === 'object') {
    const record = value as Record<string, unknown>;

    if (Array.isArray(record.options)) {
      return record.options.filter(
        (entry): entry is string => typeof entry === 'string',
      );
    }

    return Object.entries(record)
      .filter(([, enabled]) => enabled === true)
      .map(([key]) => key);
  }

  return [];
}

/**
 * Map CMS keys to raw Personio employmentType values present in the job feed.
 */
export function resolvePreselectedEmploymentTypes(
  cmsValue: unknown,
  availableOptions: string[],
): string[] {
  const availableByKey = new Map(
    availableOptions.map((option) => [
      normalizeEmploymentTypeKey(option),
      option,
    ]),
  );
  const resolved = new Set<string>();

  for (const entry of parsePreselectedEmploymentTypeOptions(cmsValue)) {
    const match = availableByKey.get(normalizeEmploymentTypeKey(entry));
    if (match) {
      resolved.add(match);
    }
  }

  return [...resolved];
}
